// Action Types for the Business Overview dashboard

export const GET_BUSINESS_OVERVIEW_DATA = "GET_BUSINESS_OVERVIEW_DATA";
export const GET_BUSINESS_OVERVIEW_DATA_SUCCESS =
  "GET_BUSINESS_OVERVIEW_DATA_SUCCESS";
export const GET_BUSINESS_OVERVIEW_DATA_ERROR =
  "GET_BUSINESS_OVERVIEW_DATA_ERROR";
